import React from "react";
import { Grid } from "@mui/material";
import { Card } from "components";
import { useApp } from "context";
import { IAppointment } from "interfaces";
import { Enums } from "utils";

type Props = {
  // TODO: it may be improved (currently being used to force the updated of the appointments)
  incrementComponent: number;
};

export const WeekAppointment = (props: Props) => {
  const { service, t, theme } = useApp();

  const [appointments, setAppointments] = React.useState([]);
  const [specialAppointments, setSpecialAppointments] = React.useState([]);

  // const shouldRefresh = checkInStatus !== Enums.EnumAppointmentStatus.None;

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await service.appointment.week();
      setAppointments(response.appointments);
      setSpecialAppointments(response.specialAppointments);
    };
    fetchData();
  }, [service.appointment, props.incrementComponent]);

  return (
    <>
      {appointments.length > 0 && (
        <Grid container spacing={theme.margin.md}>
          {appointments.map((item: IAppointment) => {
            return (
              <Grid item xs={12} sm key={item.appointmentId}>
                <Card.Weekday
                  item={item}
                  appointment={specialAppointments.find(
                    (app: IAppointment) =>
                      app.appointmentId === item.appointmentId
                  )}
                />
              </Grid>
            );
          })}
        </Grid>
      )}
    </>
  );
};
